import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Header from "../../components/header";
import { FaEdit, FaImages, FaCog, FaHome, FaInfoCircle, FaConciergeBell, FaPhone, FaColumns } from "react-icons/fa";

const sections = [
  { group: "hero", title: "Hero Section", description: "Main banner title, subtitle, and images", icon: <FaHome className="text-3xl" />, color: "from-emerald-500 to-teal-600" },
  { group: "about", title: "About Us", description: "About section text and paragraphs", icon: <FaInfoCircle className="text-3xl" />, color: "from-blue-500 to-indigo-600" },
  { group: "services", title: "Services", description: "Service titles and descriptions", icon: <FaConciergeBell className="text-3xl" />, color: "from-purple-500 to-violet-600" },
  { group: "contact", title: "Contact Info", description: "Address, phone, email", icon: <FaPhone className="text-3xl" />, color: "from-orange-500 to-red-500" },
  { group: "footer", title: "Footer", description: "Copyright text and footer content", icon: <FaColumns className="text-3xl" />, color: "from-gray-600 to-gray-800" },
  { group: "nav", title: "Navigation Labels", description: "Menu item text labels", icon: <FaEdit className="text-3xl" />, color: "from-cyan-500 to-blue-500" },
  { group: "settings", title: "Site Settings", description: "Clinic name, hours, logo", icon: <FaCog className="text-3xl" />, color: "from-amber-500 to-orange-600" },
];

export default function CmsPanel() {
  const navigate = useNavigate();
  const [user, setUser] = useState<any>(null);

  useEffect(() => {
    const userData = localStorage.getItem("user");
    if (userData) {
      const parsed = JSON.parse(userData);
      if (parsed.role !== "admin") {
        navigate("/home");
      }
      setUser(parsed);
    } else {
      navigate("/login");
    }
  }, [navigate]);

  if (!user || user.role !== "admin") return null;

  return (
    <>
      <Header />
      <main className="min-h-screen bg-gradient-to-b from-[#0a2e30] to-[#061e1f] pt-24 px-4 md:px-8">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-12">
            <h1 className="text-3xl md:text-4xl font-bold text-white mb-3">Content Management System</h1>
            <p className="text-gray-300 text-lg">Edit your website content, images, and settings</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-12">
            {sections.map((section) => (
              <button
                key={section.group}
                onClick={() => navigate(`/cms/section/${section.group}`)}
                className={`group cursor-pointer bg-gradient-to-br ${section.color} rounded-xl p-6 text-left text-white shadow-lg hover:shadow-2xl hover:scale-[1.02] transition-all duration-300`}
              >
                <div className="flex items-center gap-4 mb-3">
                  <div className="bg-white/20 rounded-lg p-3">{section.icon}</div>
                  <h2 className="text-xl font-bold">{section.title}</h2>
                </div>
                <p className="text-white/80 text-sm">{section.description}</p>
              </button>
            ))}
          </div>

          <div className="flex justify-center mb-12">
            <button
              onClick={() => navigate("/cms/media")}
              className="cursor-pointer bg-gradient-to-br from-pink-500 to-rose-600 rounded-xl p-6 text-white shadow-lg hover:shadow-2xl hover:scale-[1.02] transition-all duration-300 w-full md:w-1/2"
            >
              <div className="flex items-center justify-center gap-4">
                <div className="bg-white/20 rounded-lg p-3"><FaImages className="text-3xl" /></div>
                <div>
                  <h2 className="text-xl font-bold">Media Manager</h2>
                  <p className="text-white/80 text-sm">Upload and manage images, logos</p>
                </div>
              </div>
            </button>
          </div>
        </div>
      </main>
    </>
  );
}
